export const generateSlug = (title) => {
  if (!title) return 'property';
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric chars with hyphen
    .replace(/(^-|-$)+/g, ''); // Remove leading or trailing hyphens
};
